import React from 'react'
import { NumberPad } from '@/components/NumberPad'
import { useSavingsStore } from '@/store/useSavingsStore'
import { useUserStore } from '@/store/useUserStore'

export const FirstDepositNumberPad: React.FC = () => {
  // Store state - используем тот же подход что и в withdraw
  const isFiatMode = useSavingsStore((s) => s.goalTransferIn.isFiatMode)
  const fiatAmount = useSavingsStore((s) => s.goalTransferIn.fiatAmount)
  const cryptoAmount = useSavingsStore((s) => s.goalTransferIn.cryptoAmount)
  const setGoalTransferIn = useSavingsStore((s) => s.setGoalTransferIn)

  const user = useUserStore((s) => s.user)
  const displayCurrency = user?.display_currency || 'USD'

  // Функции для обновления сумм - прямые, как в withdraw
  const setFiatAmount = (amount: { amount: string; code: string }) => {
    setGoalTransferIn({
      fiatAmount: amount,
    })
  }

  const setCryptoAmount = (amount: { amount: string; code: string }) => {
    setGoalTransferIn({
      cryptoAmount: amount,
    })
  }

  // Создаем объект selectedCurrency с правильной структурой, как в withdraw
  const selectedCurrency = {
    code: 'USDT',
    pricePerUnit: 1.0, // USDT всегда ~1 USD
  }

  // Функция тряски - store автоматически сбросит triggerShake через 600ms
  const shakeComponent = () => {
    setGoalTransferIn({ triggerShake: true })
  }

  return (
    <NumberPad
      isFiatMode={isFiatMode}
      fiatAmount={fiatAmount}
      cryptoAmount={cryptoAmount}
      setFiatAmount={setFiatAmount}
      setCryptoAmount={setCryptoAmount}
      selectedCurrency={selectedCurrency}
      shakeComponent={shakeComponent}
      maxLength={12}
    />
  )
}
